var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"shipment"},[_c('v-container',{staticClass:"shipment-progress-bar-wrapper d-flex justify-center align-center"},[(_vm.showProgressBar)?_c('ProgressBar'):_vm._e()],1),_c('v-container',{staticClass:"shipment-container mt-7"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }